/*---------------------------------------------------------------------------------------------
 *  Copyright (c) Microsoft Corporation. All rights reserved.
 *  Licensed under the MIT License. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------*/
import * as React from 'react';

import { ILinksData } from '../farmlands-account-address-tile.props.autogenerated';

export interface IAccountAddressTileLinks {
    links: ILinksData[];
}

const AccountAddressTileLinks: React.FC<IAccountAddressTileLinks> = ({ links }) => {
    if (links.length === 0) {
        return null;
    }

    return (
        <div className='ms-account-address-tile__links'>
            {links.map((link: ILinksData, index: number) => (
                <a
                    key={index}
                    className='ms-account-address-tile__link'
                    title={link.linkText}
                    href={link.linkUrl && link.linkUrl.destinationUrl}
                    aria-label={link.ariaLabel}
                    target={link.openInNewTab ? '_blank' : undefined}
                >
                    {link.linkText}
                </a>
            ))}
        </div>
    );
};

export default AccountAddressTileLinks;